import { ConfirmSaveModal } from 'components/common/index';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import useEventWithDimensions from 'hooks/useEventWithDimensions';
import { useProjectTreeStore } from 'store/projectContract.store';
import { useMutationRefreshProgramAnalysisData } from 'api/mutations/refreshProgramAnalysisData.mutation';

export const ConfirmRefreshSubProgramModal = ({ handleModalClose, isShowModal }) => {
    const { contract } = useProjectTreeStore();
    const { mutate, isLoading } = useMutationRefreshProgramAnalysisData();
    const { handleSnackBar } = useCustomSnackBar();
    const { sendEventWithDimensions } = useEventWithDimensions();

    const handleRefreshSubProgram = () => {
        if (contract) {
            mutate(
                { contractId: contract?.id },
                {
                    onSuccess: () => {
                        handleSnackBar('Refresh started. Please wait for re-upload to complete', 'success');

                        sendEventWithDimensions({
                            category: 'Program Library',
                            action: 'Refresh Sub-Program',
                            label: contract?.title,
                        });
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                    onSettled: () => handleModalClose(),
                },
            );
        }
    };

    return (
        <ConfirmSaveModal
            isShowModal={isShowModal}
            onHideModal={handleModalClose}
            onConfirm={handleRefreshSubProgram}
            isLoading={isLoading}
            actionButtonLabel={'Refresh'}
        >
            Are you sure you want to refresh this sub-program ({contract?.title})?
        </ConfirmSaveModal>
    );
};
